import React, { useContext, useEffect, useState, useRef, } from 'react';
import { SideMenuItems, SideMenuPageList, HTTPResponse, ToastMessageType } from '../Helpers/Enums';
import { useNavigate } from 'react-router';
import { AddLocalStorageData, GetLocalStorageData, GetLoggedInUserID, formatDate } from '../Helpers/Utilities';
import { PatientService } from "../WebApiServices/Patient.service";
import { AppContext } from '../Contexts/AppContextProvider';
import { CommonError_Msgs, CommonMsgs } from "../Helpers/HelperText";
import InstructionModal from './InstructionModal';


const SideBarMenu = (props) => {
    // const [incompletePageIds, setIncompletePageIds] = useState([]);
    const activePageId = props.activePageId;
    // const isFromDemo=props?.isFromDemo;
    const patientID = GetLocalStorageData("patientId") ?? 0;
    const navigate = useNavigate();
    const { ShowToast, ToggleLoader, HandleSessionTimeout, appState, SetMDENo } = useContext(AppContext);
    //const { isSubmitted, formIncomplete } = useContext(AppContext);
    let patientData = GetLocalStorageData("patient");
    patientData = patientData && JSON.parse(patientData);
    const [eligibilityCriteriaLocked, setEligibilityCriteriaLocked] = useState(false);
    const [showHideModal, setShowHideModal] = useState(false);
    const activeRef = useRef(null);
    // const submit = patientData?.submit ?? 0;
    const locked = patientData?.locked ?? false;
    const part2locked = patientData?.part2locked ?? false;
    // const pid = patientData?.patientId ?? 0;
    // const userId = GetLocalStorageData("userId") ?? 0;

    const [pageList, setPageList] = useState(SideMenuPageList);

    const loadConfig = GetLocalStorageData("loadConfig") ?? false;

    const loadConfigTwo = GetLocalStorageData("loadConfigBirthDate") ?? false;

    const [eligible, setEligible] = useState(false);
    const [loading, setLoading] = useState(true);//https://ideawharf.sifterapp.com/issues/11480

    useEffect(() => {
        const FetchData = async () => {

            try {
                AddLocalStorageData("loadConfig", false);
                //AddLocalStorageData("loadConfigBirthDate", false);
                let transplantStartDate = "1-year pre-transplant start"; // Replace with actual value from state/props
                let stabilizationDate = "24-month post-stabilization date"; // Replace with actual value from state/props

                let SaveEligibilityIndexDate = GetLocalStorageData("SaveEligibilityIndexDate")

                //ToggleLoader(true);
                const response1 = await PatientService.IsEligiblePatient(patientID);
                const response2 = await PatientService.GetClinicalDates(patientID);

                if (response2.data != null) {
                    const clinicalDates = {
                        indexDt: formatDate(response2.data.indexDate) || SaveEligibilityIndexDate,
                        oneYr_pretransplant_start: formatDate(response2.data.oneyrPretransplantStartDate),
                        oneYr_pretransplant_end: formatDate(response2.data.oneyrPretransplantEndDate),
                        three_month_stabilization: formatDate(response2.data.threeMonthStabilizationDate),
                        post_stabilization_start: formatDate(response2.data.postStabilizationStartDate),
                        twelve_month_post_stabilization: formatDate(response2.data.twelveMonthPostStabilizationDate),
                        twenty_four_months_post_stabilization: formatDate(response2.data.twentyFourMonthsPostStabilizationDate),
                        endofFollowUpDate: formatDate(response2.data.endoffollowupDate),
                        six_month_post_stabilization: formatDate(response2.data.sixMonthPostStabilizationDate),
                        eighteen_month_post_stabilization: formatDate(response2.data.eighteenMonthPostStabilizationDate),
                        zero_to12months_before_LT_LKT: response2.data.zeroTo12monthsBeforeLtLkt,
                        zero_to_3months_after_LT_LKT: response2.data.zeroTo3monthsAfterLtLkt,
                        four_to_15months_after_LT_LKT: response2.data.fourTo15monthsAfterLtLkt,
                        sixteen_to_27months_after_LT_LKT: response2.data.sixteenTo27monthsAfterLtLkt,
                        pretransplant_start_end_criteria: response2.data.pretransplantStartEndCriteria,
                        indexdate_threemonth_criteria: response2.data.indexdateThreemonthCriteria,
                        post_stabilization_twelvemonth_criteria: response2.data.postStabilizationTwelvemonthCriteria,
                        twelvemonth_twentyfourmonth_criteria: response2.data.twelvemonthTwentyfourmonthCriteria,
                        transplant_admissionDt: formatDate(response2.data.transplantAdmissionDate),
                        transplant_dischargeDt: formatDate(response2.data.transplantDischargeDate),
                        //SYJ - 21/03/2025 - set [12-month post-stabilization date + 1 day]
                        twelve_month_post_stabilization_plusOneday: formatDate(response2.data.twelveMonthPostStabilizationDatePlusoneday),
                        beginning_follow_up: formatDate(response2.data.begginingFollowupDate),

                        closest_oneYr_priorIndex: response2.data.closestOneyrIndexDate,
                        closest_transplantAdmissionDt: response2.data.closestTransplantAdmissionDate,
                        closest_transplantDischargeDt: response2.data.closestTransplantDischargeDate,
                        closest_threeMonths_afterIndex: response2.data.closestThreeMonthIndexDate,
                        closest_fifteenMonths_afterIndex: response2.data.closestFifteenMonthIndexDate,
                        closest_twentysevenMonths_afterIndex: response2.data.closestTwentysevenMonthIndexDate,
                        closest_twentysevenMonths_afterIndex_nutrition: response2.data.closestTwentysevenMonthIndexDateNutrition,
                        closest_twentyoneMonths_afterIndex: response2.data.closestTwentyoneMonthIndexDate
                    }
                    AddLocalStorageData("ClinicalCharacteristicsDates", clinicalDates);

                    transplantStartDate = clinicalDates.oneYr_pretransplant_start === null ? transplantStartDate : clinicalDates.oneYr_pretransplant_start;
                    stabilizationDate = clinicalDates.twenty_four_months_post_stabilization === null ? stabilizationDate : clinicalDates.twenty_four_months_post_stabilization;
                }
                const isEligible = response1?.data ?? false;

                setEligible(isEligible)
                AddLocalStorageData("isEligible", isEligible);
                SetMDENo(0);
                if (response1?.status === HTTPResponse.OK) {
                    const responsePtConfig = await PatientService.GetPatientConfigData(patientID);
                    if (responsePtConfig?.status === HTTPResponse.OK) {

                        if (responsePtConfig != null) {
                            const { data } = responsePtConfig;
                            if (data != null) {
                                // const { item1, item2, item3, item4 } = data;
                                const { item1, item2 } = data; // Jenkins warning fix.
                                //const filteredItem1 = isFromDemo ? item1.filter(item => item.pageId === 5 || item.pageId === 6) : item1;

                                setEligibilityCriteriaLocked(item1[0].eligibilityCriteriaLocked ?? false);

                                const updatedSideMenuPageList = SideMenuPageList.map((item) => ({
                                    ...item,
                                    title: item.title
                                        ?.replace("[TransplantStartDate]", transplantStartDate)
                                        .replace("[StabilizationDate]", stabilizationDate),
                                }));

                                let pglistClone = [...updatedSideMenuPageList];
                                let staticPgs = [];
                                staticPgs = pglistClone.filter(a => a.id !== SideMenuItems.MDESInformation).map(obj => {
                                    // Find the corresponding object in item1 by id
                                    let matchObj = item1.find(a => a.pageId === obj.id);
                                    //update incomplete prop
                                    if (matchObj) {
                                        return {
                                            ...obj,
                                            key: obj.id, // Use id as a unique key
                                            incomplete: matchObj.incomplete
                                        };
                                    }
                                    //no match
                                    return {
                                        ...obj,
                                        key: obj.id // Ensure the key is present for unmatched objects as well
                                    };
                                });

                                let listmdes = [];
                                if (item2 != null && item2.length > 0) {
                                    SetMDENo(item2.length);
                                    // item2.map((a, i) => {
                                    //     const wkItm = {
                                    //         id: a.pageId,
                                    //         title: `MDE ${a.mdenum}`,
                                    //         path: "/MDESInformation",
                                    //         mdeNum: a.mdenum,
                                    //         hasParent: true,
                                    //         incomplete: a.incomplete,
                                    //         disabled: a.disabled,
                                    //         key: a.pageId
                                    //     };
                                    //     listmdes.push(wkItm);
                                    // })
                                    listmdes = item2.map((a, i) => ({
                                        id: a.pageId,
                                        title: `MDE ${a.mdenum}`,
                                        path: "/MDESInformation",
                                        mdeNum: a.mdenum,
                                        hasParent: true,
                                        incomplete: a.incomplete,
                                        disabled: a.disabled,
                                        ispartsection: true,
                                        key: a.pageId
                                    }));
                                    const mdenumList = listmdes.map(item => item.mdeNum);
                                    localStorage.setItem("mdenumList", JSON.stringify(mdenumList));
                                }

                                const finalList = [
                                    ...staticPgs.filter((a) => a.id < SideMenuItems.MDESInformation),
                                    ...listmdes,
                                    ...staticPgs.filter((a) => a.id === SideMenuItems.Hospitalizations),
                                    ...staticPgs.filter((a) => a.id === SideMenuItems.MMALabAssessment),
                                    ...staticPgs.filter((a) => a.id === SideMenuItems.ValidateSubmit1),
                                    ...staticPgs.filter((a) => a.id === SideMenuItems.Part2),
                                    ...staticPgs.filter((a) => a.id === SideMenuItems.NonMdeTreatment),
                                    ...staticPgs.filter((a) => a.id === SideMenuItems.RenalLabAssessment),
                                    ...staticPgs.filter((a) => a.id === SideMenuItems.OtherLabAssessment),
                                    ...staticPgs.filter((a) => a.id === SideMenuItems.MmsComplications),
                                    ...staticPgs.filter((a) => a.id === SideMenuItems.NutritionManagement),
                                    ...staticPgs.filter((a) => a.id === SideMenuItems.ValidateSubmit2)
                                ];
                                setPageList(finalList);

                            }
                        }
                        //ToggleLoader(false);
                    }
                    else if (response1?.status === HTTPResponse.Unauthorized) {
                        HandleSessionTimeout();
                    }
                    else {
                        const updatedSideMenuPageList = SideMenuPageList.map((item) => ({
                            ...item,
                            title: item.title
                                ?.replace("[TransplantStartDate]", transplantStartDate)
                                .replace("[StabilizationDate]", stabilizationDate),
                        }));
                        setPageList(updatedSideMenuPageList);
                    }
                }
                else if (response1?.status === HTTPResponse.Unauthorized) {
                    HandleSessionTimeout();
                }
            } catch (e) {
                //ToggleLoader(false);
            }
            finally {
                setLoading(false);
            }
        }

        FetchData();
    }, [loadConfig, loadConfigTwo, appState.showCartPage])//, appState.showCartPage 

    useEffect(() => {
        if (!loading && activeRef.current) {
            activeRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }, [loading, activePageId, pageList]);
    /* <summary>
    date: 04-11-2023
    Name: AP
    description: Handle Navigation with Highlight on Validate/Submit Click.
      Edited the function. Removed highlighting of incomplete forms 
        inside a useEffect since it wasn't showing up on first click.
    <summary>*/
    const HandleNavigate = async (pageUrl, mdeNum, pageId, testNum) => {
        try {
            if (pageId === SideMenuItems.ValidateSubmit1) {
                const pid = GetLocalStorageData("patientId") ?? 0;
                const payload = {
                    pid: pid,
                    userId: GetLoggedInUserID(),
                    partNo: 1
                };
                ToggleLoader(true)
                const response = await PatientService.SetPatientSubmitValue(payload);

                if (response?.status === HTTPResponse.OK) {
                    // Set Patient Submit Value in LS
                    const ptArr = { ...patientData };
                    ptArr.submit = response?.data;

                    AddLocalStorageData("patient", JSON.stringify(ptArr));
                }
            }

            if (pageId === SideMenuItems.ValidateSubmit2) {
                const pid = GetLocalStorageData("patientId") ?? 0;
                const ptArr = { ...patientData };
                console.log('ptArr: ', ptArr);
                if(ptArr.submit === 2 && ptArr.locked)
                {
                    //proceed with Validat & Submit
                    const payload = {
                        pid: pid,
                        userId: GetLoggedInUserID(),
                        partNo: 2
                    };
                    ToggleLoader(true)
                    const response = await PatientService.SetPatientSubmitValue(payload);

                    if (response?.status === HTTPResponse.OK) {
                        // Set Patient Submit Value in LS
                        const ptArr = { ...patientData };
                        ptArr.part2submit = response?.data;
                        ptArr.part2locked = response?.data === 2 ? true : false;
                        AddLocalStorageData("patient", JSON.stringify(ptArr));
                    }
                }
                else{
                    //display error
                    setShowHideModal(true)
                return; // <-- early return prevents navigation
                }
            }

            if (patientID > 0) {
                //ToggleLoader(true);
                const response = await PatientService.IsEligiblePatient(patientID);
                const isEligible = response?.data ?? false;
                const ptArr = { ...patientData }
                AddLocalStorageData("patient", JSON.stringify(ptArr))

                if (isEligible) {
                    if (pageUrl === "/MDESInformation") {
                        navigate(pageUrl + "/" + mdeNum)
                    }
                    // else if(pageUrl === "/EligibilityCriteria"){

                    // }
                    else {
                        navigate(pageUrl);
                        // if (pageUrl.trim().includes("PatientScreening")) {
                        //     navigate(pageUrl);
                        // }
                    }
                }
                else {
                    //Below code later remove when side bar locks are added
                    // if (pageUrl === "/VenetoclaxRampUpWeek") {
                    //     navigate(pageUrl + "/" + mdeNum)
                    // }
                    //if (pageUrl.trim().includes("PatientScreening") || pageUrl.trim().includes("EligibilityCriteria")) {
                    // else {
                    navigate(pageUrl);
                    // }//}
                }
                //ToggleLoader(false)
            }
            else {
                navigate(pageUrl);
            }

            ToggleLoader(false);
        } catch {

        }
    }
    
    return (
        <div className="sidebar col-pad-right" id='mySidebar'>
            <div className="tab tab-custom">
                <div className="activity-link-tab">
                    {!loading && (
                        pageList?.map((item) => (

                            <button
                                ref={
                                parseInt(activePageId, 10) === parseInt(item.id, 10)
                                    ? activeRef
                                    : null
                            }
                                key={`${item.id}-${item.mdeNum}`} // Combined key to ensure uniqueness
                                onClick={() => { HandleNavigate(item.path, item.mdeNum, item.id, item.testNum) }}
                                className={`tablinks ${(parseInt(activePageId, 10) === (parseInt(item.id, 10))) && "active"}`}
                                //className={`tablinks ${activePageId === item.id && "active"}`}
                                style={{ background: item.title?.includes('PART') && "#6C757D", color: item.title?.includes('PART') ? "white" : item.incomplete ? "red " : "white", marginLeft: (item.ispartsection && item.hasParent) ? "30px" : item.ispartsection ? "20px " : "0px" }}
                                //disabled={item.notClickable || (((patientID === 0 || !eligible) && item.id > 2))}

                                //ST: 3/12/2024: Uncomment later
                                // disabled={
                                //     item.notClickable ||
                                //     (
                                //         ( // If item.id includes "9", skip disabling
                                //             (String(item.id).includes(SideMenuItems.MDESInformation) && !eligibilityCriteriaLocked) ||
                                //             item.disabled ||
                                //             // New Patient lock all except 1st page
                                //             (patientID === 0 && item.id === SideMenuItems.PatientScreening) ||
                                //             // Patient is eligible (metINclusionCriteria)
                                //             (!eligible && item.id >= SideMenuItems.Demographics && item.id <= SideMenuItems.ValidateSubmit) ||
                                //             !eligibilityCriteriaLocked && item.id >= SideMenuItems.Demographics && item.id <= SideMenuItems.ValidateSubmit
                                //         )
                                //     )
                                // }
                                disabled={
                                    item.notClickable ||
                                    (String(item.id).includes(SideMenuItems.MDESInformation) && !eligibilityCriteriaLocked) || // MDESInformation item requires eligibilityCriteriaLocked
                                    item.disabled || // Item is directly marked as disabled
                                    (patientID === 0 && item.id === SideMenuItems.PatientScreening) || // New Patient - only allow first page
                                    (!eligible && item.id >= SideMenuItems.Demographics && item.id <= SideMenuItems.ValidateSubmit2) || // Not eligible patient
                                    (!eligibilityCriteriaLocked && item.id >= SideMenuItems.Demographics && item.id <= SideMenuItems.ValidateSubmit2) // Locked condition not met
                                }

                            >
                                <span className={`${item.hasParent && "child"} ${item.hasGrandParent && "grandchild"}`}>
                                    {
  !item.notClickable &&
  (
    (
      (item.id?.toString().includes(SideMenuItems.MDESInformation) && !eligibilityCriteriaLocked) ||
      item.disabled ||
      (patientID === 0 && item.id >= SideMenuItems.EligibilityCriteria) ||
      (!eligible && item.id >= SideMenuItems.Demographics && item.id <= SideMenuItems.ValidateSubmit2) ||
      (eligibilityCriteriaLocked && item.id === SideMenuItems.EligibilityCriteria) ||
      (!eligibilityCriteriaLocked && item.id >= SideMenuItems.Demographics && item.id <= SideMenuItems.ValidateSubmit2) ||
      (eligibilityCriteriaLocked && locked && (
        (item.id >= SideMenuItems.Demographics && item.id <= SideMenuItems.MMALabAssessment) ||
        item.id?.toString().includes(SideMenuItems.MDESInformation)
      )) ||
      (eligibilityCriteriaLocked && part2locked && (item.id >= SideMenuItems.NonMdeTreatment && item.id <= SideMenuItems.NutritionManagement))
    )
    &&
    // ❌ Skip showing lock for Part1 and Part2
    item.id !== SideMenuItems.Part1 &&
    item.id !== SideMenuItems.Part2
  )
  && (
    <img className="lock-icon" src="../Assets/images/locked.png" alt="" />
  )
}


                                    {item.id !== SideMenuItems.ValidateSubmit2
                                        ? <span dangerouslySetInnerHTML={{ __html: item.title }} />
                                        : (<span >
                                            {part2locked ? "SUBMITTED"
                                                // : submit === 1 && incompletePageIds.length === 0
                                                //   ? "Submit Patient" : item.title
                                                : item.title
                                            }
                                        </span>)
                                    }
                                </span>
                            </button>
                        ))
                    )}
                
                </div>
            </div>
            {showHideModal && (
                        <InstructionModal
                          description={CommonError_Msgs.PART_2_ERR}
                          OkClick={() => setShowHideModal(false)}
                        />
                      )}
        </div >
    )
}

export default SideBarMenu
